import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.scss'
import App from './pages/base/App'
import reportWebVitals from './reportWebVitals'
import configureStore from './redux/middleware/configureStore'
import RecaptchaWrapper from './components/RecaptchaWrapper/RecaptchaWrapper'
const root = ReactDOM.createRoot(document.getElementById('root'))
import * as atatus from 'atatus-spa'
atatus.config('5f71fcf42c4a4607a4b60ef91c0bf69e').install()
root.render(
	process.env.NODE_ENV === 'development' ? <Provider store={configureStore()}>
		<RecaptchaWrapper>
			<App />
		</RecaptchaWrapper>
	</Provider> : <React.StrictMode>
		<Provider store={configureStore()}>
			<RecaptchaWrapper>
				<App />
			</RecaptchaWrapper>
		</Provider>
	</React.StrictMode>
)
reportWebVitals()
